import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import SKUMappingForm from './SKUMappingForm';
import { Paper, withStyles, Dialog, CircularProgress } from '@material-ui/core';
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from '../../sc-utilities';
import { connect } from 'react-redux';
import * as actions from './store/skuMappingActions';
import History from '../../../History';
import AppLogoLoading from '../../sc-logo';

const styles = (theme) => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    submit: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        overflow: 'hidden',
        alignItems: 'center',
    },
    cancel: {
        width: '250px',
        margin: '10px',
    },
});

const SKUMappingEdit = (props) => {
    const {
        skuMapping,
        classes,
        onFetchSKUMappingInit,
        onFetchSKUMapping,
        activeCustomer,
        onEditSKUMapping,
        translations,
        permissions,
    } = props;
    const [data, setData] = useState(true);

    const handleSubmit = async (data) => {
        let objestToSend = { ...data };
        objestToSend['SKUMappingID'] = skuMapping.SKUMappingID;
        let result = await onEditSKUMapping({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await onFetchSKUMapping({
                ActiveCustomerID: activeCustomer,
                SKUMappingID: parseURL(window.location.href).skuMappingID,
            });
            setData(false);
        };
        fetchData();
        return () => {
            onFetchSKUMappingInit();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ProductType: skuMapping.ProductType || '',
        Vendor: skuMapping.Vendor || '',
        Model: skuMapping.Model || '',
        ProductIdentifier: skuMapping.ProductIdentifier || '',
        Storage: skuMapping.Storage || '',
        Memory: skuMapping.Memory || '',
        CPU: skuMapping.CPU || '',
        GPU: skuMapping.GPU || '',
        Grading: skuMapping.Grading || '',
        Color: skuMapping.Color || '',
        Carrier: skuMapping.Carrier || '',
        SKU: skuMapping.SKU || '',
    };

    const maxLengthValidationText = 'Maximum 255 characters are allowed';
    const maxLengthValidationFn = (val) => (val ? val?.length <= 255 : true);

    let formSettings = {
        Validation: {
            ProductType: Yup.string().required('Required'),
            Vendor: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Model: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            ProductIdentifier: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Storage: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Memory: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            CPU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            GPU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Grading: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Color: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            Carrier: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
            SKU: Yup.string().test('maxLength', maxLengthValidationText, maxLengthValidationFn),
        },
        FormTitle: translations['edit_sku_mapping'] || 'Edit SKU mapping',
        ButtonSubmit: hasPermission(permissions, 'sku_mapping_save')
            ? {
                  Title: translations['save'] || 'SAVE',
                  Color: 'primary',
              }
            : null,
    };

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit,
                    },
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data ? (
                <SKUMappingForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                />
            ) : (
                <CircularProgress variant="determinate" color="primary" size={28} />
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        skuMapping:
            state.setting.skuMappings && state.setting.skuMappings.loaded ? state.setting.skuMappings.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFetchSKUMappingInit: (skuMapping) => dispatch(actions.loadSKUMappingInit(skuMapping)),
        onFetchSKUMapping: (skuMapping) => dispatch(actions.loadSKUMapping(skuMapping)),
        onEditSKUMapping: (skuMapping) => dispatch(actions.editSKUMapping(skuMapping)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(SKUMappingEdit));
